function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoOverlay = require('../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var CloseTemplate = require('./close.template');
var ClosePrompt = /*#__PURE__*/function () {
  function ClosePrompt(app, mod) {
    _classCallCheck(this, ClosePrompt);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(app, mod, true);
    this.overlay["class"] = 'saito-overlay saitosign-overlay';
    this.hooks = {};
    this.mode = 'ask';
    this.busy = false;
    this.alive = false;
  }
  return _createClass(ClosePrompt, [{
    key: "render",
    value: function render() {
      var _this = this;
      var hooks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.hooks = hooks;
      this.mode = 'ask';
      this.busy = false;
      this.alive = true;
      this.overlay.show(CloseTemplate(this.mode, this.busy), function () {
        _this.alive = false;
        if (_this.hooks.onDismiss) {
          _this.hooks.onDismiss();
        }
      });
      this.bind();
    }
  }, {
    key: "paint",
    value: function paint() {
      var form = document.querySelector('.saitosign-close');
      if (!form || !this.alive) {
        return;
      }
      form.outerHTML = CloseTemplate(this.mode, this.busy).trim();
      this.bind();
    }
  }, {
    key: "bind",
    value: function bind() {
      var _this2 = this;
      var form = document.querySelector('.saitosign-close');
      if (!form) {
        return;
      }
      form.addEventListener('click', function (event) {
        var choice = event.target.closest('[data-close]');
        if (!choice || choice.disabled || _this2.busy) {
          return;
        }
        event.preventDefault();
        var action = choice.dataset.close;
        if (action === 'cancel') {
          _this2.overlay.close();
          return;
        }
        if (action === 'leave' && _this2.hooks.onLeave) {
          _this2.alive = false;
          _this2.overlay.close();
          _this2.hooks.onLeave();
          return;
        }
        if (action === 'export' && _this2.hooks.onExport) {
          _this2.busy = true;
          _this2.mode = 'exporting';
          _this2.paint();
          Promise.resolve(_this2.hooks.onExport()).then(function (saved) {
            if (!_this2.alive) {
              return;
            }
            _this2.busy = false;
            _this2.mode = saved ? 'saved' : 'error';
            _this2.paint();
          })["catch"](function () {
            if (!_this2.alive) {
              return;
            }
            _this2.busy = false;
            _this2.mode = 'error';
            _this2.paint();
          });
        }
      });
    }
  }]);
}();
module.exports = ClosePrompt;